import { render } from "./tooltip_uikits.vue?vue&type=template&id=540736eb"
import script from "./tooltip_uikits.vue?vue&type=script&lang=js"
export * from "./tooltip_uikits.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__